import { Box, Typography } from "@mui/material"
import React, { FormEvent, useCallback, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { customPalette } from "../../../../../../../../../theme"
import { CustomBottomNavigation } from "../../../../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { IconInbox } from "../../../../../../../../components/custom-icons/icon-inbox"
import { SuccessContext } from "../../../../../../../../components/layout/success-snackbar"
import { pagesUrl } from "../../../../../../../../core/appConstants"
import { AppSideBarContext } from "../../../../../../../../core/context/AppSideBarContext/AppSideBarContext"
import { BSVariantContext } from "../../../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext, NavbarTypeEnum } from "../../../../../../../../core/context/nav-bar/AppNavBarContext"
import { CoverImgProjectContext } from "../../../../../../../../core/context/project/CoverImgProjectContext"
import { ProjectContext } from "../../../../../../../../core/context/project/ProjectContext"
import { resolveUrl } from "../../../../../../../../core/services/http-service"
import { BSBuildingContext } from "../../components/context/BSBuildingContext"
import { BSParkingFormDialog } from "../BSBuildingParkingPage/components/BSParkingFormDialog"
import { BSParkingContext } from "../BSBuildingParkingPage/context/BSParkingContext"
import { BSBuildingZoneContainer } from "./components/BSBuildingZoneNoBim/BSBuildingZoneContainer"
import { BSLevelContext } from "./context/BSLevelContext"
import { BSLevelFormContext, BSLevelFormContextProvider } from "./context/BSLevelFormContext"
import { BSUsageContext, BSUsageContextProvider } from "./context/BSUsageContext"

export function BSZoneAndLevelPage(): React.JSX.Element {
  return (
    <BSUsageContextProvider>
      <BSLevelFormContextProvider>
        <BSZoneAndLevelPageCore />
      </BSLevelFormContextProvider>
    </BSUsageContextProvider>
  )
}

function BSZoneAndLevelPageCore(): React.JSX.Element {
  const navigate = useNavigate()

  const { setShowAppSide, setFullScreen } = useContext(AppSideBarContext)
  const { setTypeNavBar, setImageFile, setIcon, setTitle, setPreviousUrl, setStepHeader } = useContext(AppNavBarContext)
  const { file } = useContext(CoverImgProjectContext)
  const { project } = useContext(ProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)
  const openSuccessSnackbar = useContext(SuccessContext)
  const { setIsLevelUpdated } = useContext(BSLevelContext)
  const { isLevelListSubmitting, setIsLevelListSubmitting, submitBSBuildingLevelForm, validateLevelForm } =
    useContext(BSLevelFormContext)
  const { isParkingFormOpen, setIsParkingFormOpen, isParkingFormForSuperstructure } = useContext(BSParkingContext)
  const { handleSubmit: handleSubmitUsage, isSubmitting } = useContext(BSUsageContext)

  useEffect(() => {
    setTypeNavBar(NavbarTypeEnum.BUILDING_HEADER)
    setImageFile(file)
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
    setTitle(selectedVariant?.name ?? "")
    setPreviousUrl(
      resolveUrl(pagesUrl.BUILDING_PARKING, [
        project?.id,
        selectedVariant?.id,
        selectedBSBuilding?.id,
        selectedBSBuilding?.bsBimModelId,
      ])
    )
    setFullScreen(false)
    setStepHeader(3)
  }, [
    file,
    project?.id,
    selectedBSBuilding?.bim,
    selectedBSBuilding?.bsBimModelId,
    selectedBSBuilding?.id,
    selectedVariant?.id,
    selectedVariant?.name,
    setFullScreen,
    setIcon,
    setImageFile,
    setPreviousUrl,
    setStepHeader,
    setTitle,
    setTypeNavBar,
  ])

  useEffect(() => {
    setShowAppSide(false)
  }, [setShowAppSide])

  const handleSubmitLevel: () => Promise<void> = useCallback(() => {
    if (selectedBSBuilding && !selectedBSBuilding?.bim && validateLevelForm()) {
      setIsLevelListSubmitting(true)
      return submitBSBuildingLevelForm(selectedBSBuilding.id).then(() => {
        setIsLevelUpdated(false)
      })
    } else {
      return Promise.resolve()
    }
  }, [
    selectedBSBuilding,
    validateLevelForm,
    setIsLevelListSubmitting,
    submitBSBuildingLevelForm,
    openSuccessSnackbar,
    setIsLevelUpdated,
  ])

  const handleSubmit: (event: FormEvent<HTMLFormElement>) => Promise<any> = useCallback(
    (event) => {
      event.preventDefault()

      return handleSubmitUsage().then(() =>
        handleSubmitLevel().then(() => {
          const url = selectedBSBuilding?.bim ? pagesUrl.BUILDING_FONDATION : pagesUrl.BUILDING_PATIO
          navigate(resolveUrl(url, [project?.id, selectedVariant?.id, selectedBSBuilding?.id]))
        })
      )
    },
    [
      handleSubmitLevel,
      handleSubmitUsage,
      navigate,
      project?.id,
      selectedBSBuilding?.bim,
      selectedBSBuilding?.id,
      selectedVariant?.id,
    ]
  )

  return (
    <>
      <Box
        component="form"
        id="create-usage-and-level"
        onSubmit={handleSubmit}
        display="flex"
        flexDirection="column"
        alignItems="center"
        px={5}
        pb={3}
        gap={3}>
        <Typography variant="h5" fontWeight={600} p={3}>
          Paramétrer les niveaux et les zones du bâtiment
        </Typography>

        <BSBuildingZoneContainer />

        <CustomBottomNavigation
          actionLabel="Continuer"
          formId="create-usage-and-level"
          isSubmitting={isLevelListSubmitting || isSubmitting}
        />
      </Box>

      {/* as its a form dialog, it has to be out of the main form */}
      <BSParkingFormDialog
        isOpen={isParkingFormOpen}
        setIsOpen={setIsParkingFormOpen}
        isSuperstructure={isParkingFormForSuperstructure}
      />
    </>
  )
}
